import React from "react";
import { View } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function ArrowAscending(props) {
  const { fillColor = "#2D3142" } = props;
  const width = props.width || 24;
  const height = props.height || 24;

  return (
    <View style={props.style}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3506 9.38981C11.7096 8.98204 12.2917 8.98204 12.6507 9.38981L16.3147 13.5515C16.4871 13.7473 16.584 14.0129 16.584 14.2898C16.584 14.8665 16.1724 15.334 15.6647 15.334L8.3366 15.334C8.09279 15.334 7.85897 15.224 7.68657 15.0282C7.32757 14.6204 7.32757 13.9593 7.68657 13.5515L11.3506 9.38981V9.38981Z"
          fill={fillColor}
        />
      </Svg>
    </View>
  );
}
